type ToastVariant = "success" | "error" | "pending";

const ICONS: Record<ToastVariant, string> = {
  success:
    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6L9 17l-5-5"/></svg>',
  error:
    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M18 6L6 18M6 6l12 12"/></svg>',
  pending:
    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M12 3a9 9 0 109 9"/></svg>',
};

export interface ToastAction { label: string; onClick: () => void }

// ms = 0 keeps the toast up until the next showToast call.
export function showToast(message: string, variant: ToastVariant = "success", ms = 1800, action?: ToastAction): void {
  let el = document.getElementById("autosave-toast");
  if (!el) {
    el = document.createElement("div");
    el.id = "autosave-toast";
    el.setAttribute("role", "status");
    document.body.appendChild(el);
  }
  el.classList.toggle("is-error", variant === "error");
  el.classList.toggle("is-pending", variant === "pending");
  el.innerHTML = `${ICONS[variant]}<span></span>`;
  // textContent, not interpolation — the message can carry a server error string.
  const label = el.querySelector("span");
  if (label) label.textContent = message;
  if (action) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "toast-action";
    button.textContent = action.label;
    button.addEventListener("click", () => {
      el?.classList.remove("show");
      action.onClick();
    }, { once: true });
    el.appendChild(button);
  }

  el.classList.add("show");
  window.clearTimeout((el as any)._hideTimer);
  if (ms > 0) {
    (el as any)._hideTimer = window.setTimeout(() => el && el.classList.remove("show"), ms);
  }
}
